/* import __COLOCATED_TEMPLATE__ from './reasons-bar-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';
import { type ReasonData } from './reasons-interactive-bar';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Args: {
    reason: string;
    reasonDescription: string;
    share: number;
    reasonData: ReasonData;
    icon: InterfaceIconName;
  };
}

const ReasonsBarTooltip = templateOnlyComponent<Signature>();
export default ReasonsBarTooltip;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::ReasonsBarTooltip': typeof ReasonsBarTooltip;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/reasons-bar-tooltip': typeof ReasonsBarTooltip;
  }
}
